import config from 'src/config'
import { tItems } from 'src/shared/frontendTypes/warenkorb'

export const isFreightShippingType = (shippingType: number) =>
  shippingType === 20 || shippingType === 30

export const canDeliverToCountry = (countryIso?: string) => (
  config.deliveryCountries.length === 0
  || config.deliveryCountries.includes(String(countryIso || '').trim().toUpperCase())
)

export const hasFreightShippingItems = (items: tItems | Record<string, { shippingType: number }>) =>
  Object.values(items).some(item => isFreightShippingType(item.shippingType))

export const getFreightShippingCost = (countryIso?: string): number | null => {
  if (!countryIso || countryIso === 'DE') return config.versandkosten.spedition

  const countryCost = config.versandkosten.speditionAusland?.[countryIso]
  return typeof countryCost === 'number' ? countryCost : null
}

export const canOrderFreightShipping = (
  items: tItems | Record<string, { shippingType: number }>,
  countryIso?: string,
) =>
  !hasFreightShippingItems(items) || getFreightShippingCost(countryIso) !== null
